<bui-group>
	<div class="container">
		<span [innerHtml]="message"></span>
	</div>
</bui-group>
<bui-group>
	<div class="linkContainer">
		<a class="defaultLink" target="" href="/jump-to-homepage-prepare.do">
			<span>{{ backToHomepageLink }}</span>
		</a>
	</div>
</bui-group>